import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import introVideo from './01-intro.webm';
import profileImage from './02-jona.png';

export const slide = () => {
  return (
    <Slide notes="Introduction profile" visualizer="hidden">
      <WebContent>
        <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none object-cover opacity-20"
            src={introVideo}
          />
        </div>
      </WebContent>
      <div className="relative z-10 flex items-center justify-center gap-12 h-full">
        <img src={profileImage} alt="Profile" className="h-[50vh] w-auto object-contain" />
        <p>
          Even voorstellen,
          <br />
          mijn naam is
          <br />
          <br />
          Jonathan IJzerman
        </p>
      </div>
    </Slide>
  );
};
